import { render, staticRenderFns } from "./AdminElements.vue?vue&type=template&id=d6038448&scoped=true"
import script from "./AdminElements.vue?vue&type=script&lang=js"
export * from "./AdminElements.vue?vue&type=script&lang=js"
import style0 from "./AdminElements.vue?vue&type=style&index=0&id=d6038448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6038448",
  null
  
)

export default component.exports